export class Nakshatra {
    id: number;
    nakshatra_name: string;
    name?:string;
}


// WEBPACK FOOTER //
// ./src/models/Nakshatra.ts